import download from 'downloadjs';

/**
 * Função para realizar o download de uma imagem
 * @param {string|object} image - URL da imagem ou objeto contendo a URL e metadados
 * @returns {Promise<void>}
 */
export const handleImageDownload = async (image) => {
  try {
    // console.log('Iniciando download da imagem...');
    // console.log('Parâmetro recebido:', image);	

    // Determinar qual é a URL da imagem baseado no formato do parâmetro
    let imageUrl;

    if (typeof image === 'string') {
      // Caso 1: É uma string direta (URL)
      imageUrl = image;
    } else if (image && typeof image === 'object') {
      // Caso 2: É um objeto - verificar propriedades comuns
      if (image.imagem) {
        // Caso do formato JSON que você mostrou
        imageUrl = image.imagem;
      } else {
        // Outros formatos possíveis
        imageUrl = image.url || image.imagem_url || image.src || image.link;
      }
    }
    
    if (!imageUrl) {
      throw new Error('URL de imagem não encontrada');
    }
    
    // Extrair o nome do arquivo da URL
    // 1. Primeiro remove qualquer parâmetro de consulta (após o '?')
    const urlSemParametros = imageUrl.split('?')[0];
    // 2. Pega a parte após a última barra '/'
    const fileName = urlSemParametros.split('/').pop();

    try {
      const response = await fetch(imageUrl, { mode: 'cors', cache: 'no-cache' });
      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status}`);
      }
      const blob = await response.blob();
      download(blob, fileName, blob.type || 'image/jpeg');
    } catch (fetchError) {
      console.log('Erro no fetch, tentando método alternativo:', fetchError);
      // Fallback para método direto
      window.open(imageUrl, '_blank');
    }
    
    
    // console.log(`Download da imagem "${fileName}" iniciado com sucesso`);
  } catch (error) {
    console.error('Erro ao fazer download da imagem:', error);
    throw error; // Propaga o erro para ser tratado por quem chamou a função
  }
};